import URI from 'urijs'
import _ from 'underscore'
import {TASK_MANAGEMENT_RELATIVE_PATH} from 'constants'
import {CUSTOMER_ID_QUERY_KEY, PROJECT_ID_QUERY_KEY, TASK_ID_QUERY_KEY} from './constants'
import {isInt} from '../../atUtils'

/**
 * Get num id from query by key
 * Take url from current location into browser
 * @param queryKey key of id
 * @returns {*} null or id of entity
 */
export const getIdFromQuery = (queryKey) => {
    const uri = URI()
    const hasKey = uri.hasQuery(queryKey)
    if (hasKey) {
        let value = getExtractedParamFromUrlByQuery(uri, queryKey)

        if (value !== null
            && value.length !== 0
            && isInt(value)) {
            return Number(value)
        }
        return null
    } else {
        return null
    }
}

export const getStringFromQuery = (queryKey) => {
    const uri = URI()
    const hasKey = uri.hasQuery(queryKey)
    if (hasKey) {
        let value = getExtractedParamFromUrlByQuery(uri, queryKey)

        if (value !== null
            && value.length !== 0) {
            return value
        }
        return null
    } else {
        return null
    }
}

export const removeUrlParamFromQuery = (queryKey) => {
    window.history.replaceState({}, '', URI().removeQuery([queryKey]))
}

export const replaceIdIntoQuery = (queryKey, id, prevId) => {
    window.history.replaceState({}, '', URI().removeQuery(queryKey, prevId).addQuery(queryKey, id))
}

export const createAbsoluteLinkToEntity = (queryKey, id) => {
    return URI()
        .pathname(URI.joinPaths(window.BASE_PATH, TASK_MANAGEMENT_RELATIVE_PATH))
        .query({[queryKey]: id})
        .toString()
}

export const createLinkToTask = (id) => createAbsoluteLinkToEntity(TASK_ID_QUERY_KEY, id)
export const createLinkToProject = (id) => createAbsoluteLinkToEntity(PROJECT_ID_QUERY_KEY, id)
export const createLinkToCustomer = (id) => createAbsoluteLinkToEntity(CUSTOMER_ID_QUERY_KEY, id)

function getExtractedParamFromUrlByQuery(uri, queryKey) {
    let value = uri.query(true)[queryKey]
    if (_.isArray(value)) {
        value = value[0]
    }
    return value
}



// WEBPACK FOOTER //
// ./web/js/panels/urlHelper/utils.js